<template>
  <router-view />
</template>

<script>
import { onMounted } from "vue";
import { useWebSocket } from '@/utils/websocket.js'; // 引入上面的文件
import store from "@/store/index.js";

export default {
  name: "App",
  setup() {
    onMounted(() => {
      store.state.websocket = useWebSocket();
      store.state.websocket.connectSocket();
      

    });

    return {};
  },
};
</script>

<style scoped>
/* 设置滚动条的样式 */

html,
body {
  font-family: "PingFang SC", "Helvetica Neue", "Helvetica", "Arial";
  width: 100%;
  height: 100%;
  color: #2c3e50;
  margin: 0;
  padding: 0;
  overflow-x: hidden;
  box-sizing: border-box;
  overflow-y: hidden;
}
</style>
